import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PLANS, mapDbRowToPlan, type Plan, type PlanType } from "@/lib/plans";

export function usePlans() {
  const { data: plans = PLANS, isLoading } = useQuery({
    queryKey: ["subscription-plans"],
    queryFn: async (): Promise<Plan[]> => {
      const { data, error } = await supabase
        .from("subscription_plans")
        .select("*")
        .order("sort_order", { ascending: true });

      if (error) throw error;
      if (!data || data.length === 0) return PLANS;

      return data.map(mapDbRowToPlan);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    // On error, React Query will return the initialData / previous data
    // but we set placeholderData as fallback
    placeholderData: PLANS,
  });

  const getPlan = (type: PlanType): Plan => {
    return plans.find(p => p.planType === type) || PLANS.find(p => p.planType === type) || PLANS[0];
  };

  return { plans, isLoading, getPlan };
}
